<div>
  <app-company-picker-modal (DataLoaded)="BindAccountSelect($event)" [IsModal]="false" [DisplayList]="ShowList"></app-company-picker-modal>

  @if (NoAccounts) {
    <h5>You do not have access to any accounts.  Please contact support.</h5>
  }
</div>
